import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { formDataSaqDsp } from "../../data/4.0/formDataSaqDsp";
import ComponentSaq from "../../components/ComponentSaq";

class SaqdMe extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {};
  }

  render() {
    return <ComponentSaq type="D-SP" formDataSaq={formDataSaqDsp} />;
  }
}

const mapStateToProps = (state) => {
  return {
    res: state.authStore.res,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(SaqdMe);
